import Redis from '../assets/skills/redis.webp'
import Mysql from '../assets/skills/mysql.png'
import Docker from '../assets/skills/docker-shakil.png'
import GraphQL from '../assets/skills/graphql-dot-com.jpg'

import Aws from '../assets/skills/aws.png'

{
    /* 
    
    https://i.ibb.co/XphSfGM/html.png
    https://i.ibb.co/zNR3L58/css.png
    https://i.ibb.co/mqKVWyF/bootstrap.png
    https://i.ibb.co/1XfsGsF/tailwind.png
    https://i.ibb.co/z2T99xR/material.png
    https://i.ibb.co/Y2pYQmj/js.png
    https://i.ibb.co/SJzJZRz/react.png
    https://i.ibb.co/jfLnCtN/redux.png
    https://i.ibb.co/CWhNhww/git.png
    https://i.ibb.co/2gWFH0M/firebase.png
    https://i.ibb.co/Bw4L3kX/node.png
    https://i.ibb.co/RvqzmDD/express.png
    https://i.ibb.co/QKTPSkD/mongoose.png
    https://i.ibb.co/4SD2Ynn/mongodb.png
            https://i.ibb.co/B3LKCxR/django.png
            https://i.ibb.co/cDnQR6C/next.png
            https://i.ibb.co/x1gWZCm/python.png

*/
}

export const skillsData = [
    {
        img: "https://i.ibb.co/XphSfGM/html.png",
        name: "Html5",
    },
    {
        img: "https://i.ibb.co/zNR3L58/css.png",
        name: "Css",
    },
    {
        img: "https://i.ibb.co/mqKVWyF/bootstrap.png",
        name: "Bootstrap",
    },
    {
        img: "https://i.ibb.co/1XfsGsF/tailwind.png",
        name: "Tailwind CSS",
    },

    {
        img: "https://i.ibb.co/Y2pYQmj/js.png",
        name: "Javascript",
    },
    {
        img: "https://i.ibb.co/SJzJZRz/react.png",
        name: "React JS",
    },
    {
        img: "https://i.ibb.co/RDmXY0t/nextjs.png",
        name: "Next JS",
    },
    {
        img: "https://i.ibb.co/jfLnCtN/redux.png",
        name: "Redux Toolkit",
    },
    {
        img: "https://i.ibb.co/CWhNhww/git.png",
        name: "Git",
    },
    {
        img: "https://i.ibb.co/2gWFH0M/firebase.png",
        name: "Firebase",
    },
    {
        img: "https://i.ibb.co/Bw4L3kX/node.png",
        name: "Node JS",
    },
    {
        img: "https://i.ibb.co/RvqzmDD/express.png",
        name: "Express JS",
    },
    {
        img: "https://i.ibb.co/QKTPSkD/mongoose.png",
        name: "Mongoose",
    },
    {
        img: "https://i.ibb.co/4SD2Ynn/mongodb.png",
        name: "MongoDB",
    },
    {
        img: "https://i.ibb.co/7NvMmN6/postman-logo-vert-2018.jpg",
        name: "PostMan",
    },
    {
        img: "https://i.ibb.co/QcjTm1w/Postgresql.png",
        name: "PostgresQl",
    },
    {
        img: "https://i.ibb.co/HgH1YsY/Prisma.webp",
        name: "Prisma",
    },
    {
        img: Redis,
        name: "Redis",
    },
    {
        img: Mysql,
        name: "Mysql",
    },
    {
        img: Docker,
        name: "Docker",
    },
    {
        img: Aws,
        name: "Aws",
    },
    {
        img: GraphQL,
        name: "GraphQL",
    },

];
